// Environment configuration helper
export const environment = {
  // Mode detection
  isDevelopment: import.meta.env.MODE === 'development',
  isProduction: import.meta.env.MODE === 'production',
  mode: import.meta.env.MODE,

  // API Configuration
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL, // With /v1 for auth routes
    url: import.meta.env.VITE_API_URL, // Without /v1 for other routes
    domain: import.meta.env.VITE_API_DOMAIN,
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  },

  // Alias for easier access
  get apiBaseUrl() {
    return this.api.baseUrl || this.getApiUrl();
  },

  get apiUrl() {
    return this.api.url || this.api.baseUrl?.replace('/v1', '') || this.getApiUrl().replace('/v1', '');
  },

  // KyoZap Configuration
  kyozap: {
    apiUrl: import.meta.env.VITE_KYOZAP_API_URL,
    wsUrl: import.meta.env.VITE_KYOZAP_WS_URL,
    apiKey: import.meta.env.VITE_KYOZAP_API_KEY,
    webhookUrl: import.meta.env.VITE_KYOZAP_WEBHOOK_URL,
    maxRetries: Number(import.meta.env.VITE_KYOZAP_MAX_RETRIES) || 3,
    // Timeout otimizado para Cloudflare WebSocket (15 segundos)
    timeout: Number(import.meta.env.VITE_KYOZAP_TIMEOUT) || 15000,
  },

  // WebSocket Configuration
  websocket: {
    port: import.meta.env.VITE_WS_PORT || '8001',
    host: import.meta.env.VITE_WS_HOST || 'localhost',
  },

  // Application Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'LavadorPro',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    domain: import.meta.env.VITE_APP_DOMAIN || 'localhost:3000',
    siteUrl: import.meta.env.VITE_SITE_URL,
  },

  // Debug Configuration
  debug: {
    enabled: import.meta.env.VITE_DEBUG_MODE === 'true',
    logLevel: import.meta.env.VITE_LOG_LEVEL || 'info',
  },

  // Helper functions
  getWebSocketUrl(): string {
    if (this.kyozap.wsUrl) {
      return this.kyozap.wsUrl;
    }

    const protocol = this.isProduction ? 'wss:' : 'ws:';
    const host = this.websocket.host;
    const port = this.websocket.port;

    return `${protocol}//${host}:${port}/ws`;
  },

  getApiUrl(): string {
    // Prefer explicit API base URL when available. KyoZap API URL is a specialized service
    // and should not override the main API base URL. If `api.baseUrl` is not set, fall
    // back to kyozap.apiUrl only as a last resort.
    if (this.api.baseUrl) {
      return this.api.baseUrl;
    }

    if (this.kyozap.apiUrl) {
      return this.kyozap.apiUrl;
    }

    return this.isProduction ? 'https://api.kyojs.com.br/v1' : 'http://192.168.0.236:3333/v1';
  },

  // Log helper
  log(message: string, ...args: any[]): void {
    if (this.isDevelopment || this.debug.enabled) {
      console.log(`[${this.mode.toUpperCase()}]`, message, ...args);
    }
  },

  // Error helper
  error(message: string, ...args: any[]): void {
    console.error(`[${this.mode.toUpperCase()}] ERROR:`, message, ...args);
  },
};

// Export for easy access
export const { isDevelopment, isProduction, mode } = environment;
export default environment;
